import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Getting Started`}</h1>
    <ul>
      <li parentName="ul">{`SASS toolkit is 7kb gzipped`}</li>
      <li parentName="ul">{`JS tools are individually transpiled via babel. There is no "opt into all".`}</li>
    </ul>
    <h2>{`Installation`}</h2>
    <p>{`Install `}<inlineCode parentName="p">{`magic-tricks`}</inlineCode>{` via yarn or npm.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-terminal"
      }}>{`$ npm i magic-tricks --save
`}</code></pre>
    <h2>{`Importing Scripts`}</h2>
    <p>{`All scripts are compiled and found in the `}<inlineCode parentName="p">{`lib`}</inlineCode>{` directory. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import capitalize from 'magic-tricks/lib/capitalize';
import centsToPrice from 'magic-tricks/lib/centsToPrice';

capitalize('sup') // Sup
centsToPrice(100) // '$1.00'
`}</code></pre>
    <h2>{`Importing SASS`}</h2>
    <p>{`All styles are found in the `}<inlineCode parentName="p">{`sass`}</inlineCode>{` directory. You can electively import the utilities you'd like to use like so. `}<em parentName="p">{`Make sure your compiler is set up to alias `}<inlineCode parentName="em">{`~`}</inlineCode>{` to `}<inlineCode parentName="em">{`node_modules`}</inlineCode></em>{`. Check out `}<a parentName="p" {...{
        "href": "/docs/sass"
      }}>{`SASS`}</a>{` for more info.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-scss"
      }}>{`// Configuration
@import '~magic-tricks/sass/config';

//                                          //
// === Put Configuration Overrides Here === //
//                                          //

// Mixins
@import '~magic-tricks/sass/mixins';

// CSS Reset
@import '~magic-tricks/sass/reset';

// Utilities
@import '~magic-tricks/sass/utils/alignment';
@import '~magic-tricks/sass/utils/background';
@import '~magic-tricks/sass/utils/border';
@import '~magic-tricks/sass/utils/color';
@import '~magic-tricks/sass/utils/cursor';
@import '~magic-tricks/sass/utils/display';
@import '~magic-tricks/sass/utils/float';
@import '~magic-tricks/sass/utils/font-weight';
@import '~magic-tricks/sass/utils/margin';
@import '~magic-tricks/sass/utils/opacity';
@import '~magic-tricks/sass/utils/overflow';
@import '~magic-tricks/sass/utils/pointer-events';
@import '~magic-tricks/sass/utils/position';
@import '~magic-tricks/sass/utils/text-align';
@import '~magic-tricks/sass/utils/transform';
@import '~magic-tricks/sass/utils/transitions';
@import '~magic-tricks/sass/utils/whitespace';
@import '~magic-tricks/sass/utils/z-index';
@import '~magic-tricks/sass/utils/flex';

// Utility Components
@import '~magic-tricks/sass/components/grid';
@import '~magic-tricks/sass/components/grid-container';
@import '~magic-tricks/sass/components/inline-grid';
@import '~magic-tricks/sass/components/list';
@import '~magic-tricks/sass/components/media';
@import '~magic-tricks/sass/components/spacer';
@import '~magic-tricks/sass/components/visibility';
`}</code></pre>
    <hr></hr>
    <a href="/docs/sass" className="button--primary fw">
	Next: SASS
    </a>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components = {}) => [{
  id: undefined,
  level: 2,
  title: "Installation",
  children: [{
    id: undefined,
    level: 2,
    title: "Importing Scripts",
    children: [{
      id: undefined,
      level: 2,
      title: "Importing SASS",
      children: []
    }]
  }]
}];
      